import React, { useEffect, useState } from 'react';
import ParentDocCard from '../../common/ParentDocCard';
import { DateFormat } from './DateFormat/DateFormat';
import CustomDomains from './DateFormat/CustomDomains/CustomDomains';
import { RefreshProject } from './RefreshProject/RefreshProject';
import ImportProject from '../environments/ImportProject';
import { DataMasking } from './DataMasking/DataMasking';
import { isProjectReadOnly } from '../../../common/utils/api_utils';

export const AppConfigTab = ({
  projectId,
  version,
  dateFormat,
  updateDateFormat,
  toggle,
  actions,
  dataMaskingConfig,
}) => {
  const [projectData, setProjectData] = useState({});
  useEffect(() => {
    const getData = async () => {
      const response = await actions.fetchProject({ projectId });
      const { data } = response;
      setProjectData(data);
    };
    getData();
  }, []);
  const isReadOnly = isProjectReadOnly(projectId);
  return (
    <>
      <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 drapcode">
        <DataMasking
          projectId={projectId}
          version={version}
          actions={actions}
          dataMasking={dataMaskingConfig}
          isReadOnly={isReadOnly}
        />
        <RefreshProject
          projectId={projectId}
          version={version}
          actions={actions}
          isReadOnly={isReadOnly}
        />
        <DateFormat
          projectId={projectId}
          version={version}
          dateFormat={dateFormat}
          updateDateFormat={updateDateFormat}
          isReadOnly={isReadOnly}
        />
        <CustomDomains
          projectDetail={projectData}
          actions={actions}
          projectId={projectId}
          version={version}
          isReadOnly={isReadOnly}
        />
        <ImportProject
          projectDetail={projectData}
          actions={actions}
          projectId={projectId}
          version={version}
          isReadOnly={isReadOnly}
        />
      </div>
      <ParentDocCard>
        <h5>
          <b>About App Setting Date Format</b>
        </h5>
        <p>DrapCode supports multiple format for date you can choose according to you</p>
        <br />
      </ParentDocCard>
    </>
  );
};
